(function(app) {

    app.constant("months",
        [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]);

})(window.app); //jshint ignore:line